/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HumanityTokenSummaryInfo } from './HumanityTokenSummaryInfo';

export type HumanityTokenInfo = {
    ADDR: HumanityTokenSummaryInfo;
    TKNT: HumanityTokenInfo.TKNT;
    PRC: string;
    PRC24H: string;
    MKC: string;
    VOL24H: string;
    HD: string;
};

export namespace HumanityTokenInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

